module.exports = __webpack_public_path__ + "img/Anna-Lena.f11f42cf.jpg";